import React from "react";

import { useLoginSharedData, useLoginSteps } from "../../hooks";

export const useLoginCredentialsStep = () => {
  const { sharedData, setUserDetails } = useLoginSharedData();
  const { onNextStep } = useLoginSteps();

  const handleSubmitLogin = React.useCallback(
    (response, userEmail = "") => {
      const { token, user, otp_required } = response;

      if (otp_required) {

        setUserDetails({
          userId: user?.id ?? response.user_id,
          userEmail: userEmail,
        });

        onNextStep();

        return;
      }

      sharedData?.successCallback({ token, user });
    },
    [onNextStep, setUserDetails, sharedData]
  );

  return {
    handleSubmitLogin,
  };
};
